import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Button, Typography } from "@mui/material";

import APP_ROUTES from "../../../../../routers/routeConstants";

import BGImage from "../../../assets/images/unlock-bg-section.png";

const UnlockSection = () => {
  const { t } = useTranslation("goHire", { keyPrefix: "goHirePage" });

  const navigate = useNavigate();
  const handleGetPremium = () => {
    navigate(APP_ROUTES.PLANS_OVERVIEW);
  };
  const handleViewAllPlans = () => {
    navigate(APP_ROUTES.PLANS);
  };
  return (
    <Box sx={styles.container} component="section">
      <Box component="img" src={BGImage} sx={styles.bgImage} />
      <Box sx={styles.content}>
        <Typography sx={styles.title}>{t("unlockAdvancedHiringToolsWithGoalngoPro")}</Typography>
        <Typography sx={styles.subtitle}>{t("accessPowerfulRecruitmentFeatures")}</Typography>
      </Box>
      <Box sx={styles.buttonsContainer}>
        <Button variant="primary-md" sx={styles.getPremiumButton} onClick={handleGetPremium}>
          {t("getPremium")}
        </Button>
        <Button variant="outlined-md" sx={styles.viewAllPlansButton} onClick={handleViewAllPlans}>
          {t("viewAllPlans")}
        </Button>
      </Box>
    </Box>
  );
};

export default UnlockSection;

const styles = {
  container: {
    position: "relative",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    borderRadius: "12px",
    padding: "32px",
    gap: "16px",
    background: "linear-gradient(269deg, #9D00EC 0.55%, #1F3693 98.76%)",
  },
  content: {
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  title: {
    color: "var(--White, #FFF)",
    fontFamily: "Montserrat",
    fontSize: "30px",
    fontStyle: "normal",
    fontWeight: 750,
    lineHeight: "normal",
  },
  subtitle: {
    color: "var(--White, #FFF)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "20px",
  },
  getPremiumButton: {
    background: "var(--White, #FFF) !important",
    color: "var(--Black-100, #1C1C1C) !important",
  },
  viewAllPlansButton: {
    borderColor: "var(--White, #FFF) !important",
    color: "var(--White, #FFF) !important",
    background: "transparent !important",
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
  },
  bgImage: {
    position: "absolute",
    right: "32px",
    top: "14PX",
    width: "356px",
    height: "178px",
    zIndex: 1,
  },
};
